import { type FC } from 'react'
import { Menu, Search } from 'lucide-react'
import { useUIStore } from '@/store'
import { UserMenu } from './UserMenu'
import { Input } from '@/components/ui/input'
import { Badge } from '@/components/ui/badge'
import SuperAdminIcon from '../../assets/superadmin.svg?url'

interface HeaderProps {
    title?: string
}

const Header: FC<HeaderProps> = () => {
    const { toggleMobileSidebar } = useUIStore()

    return (
        <header className="sticky top-0 z-20 border-b border-border bg-background/95 backdrop-blur supports-backdrop-filter:bg-background/60">
            <div className="flex justify-between h-20 items-center gap-4 px-6">
                {/* Mobile menu button */}
                <div className="flex gap-4">
                    <button
                        onClick={toggleMobileSidebar}
                        className="lg:hidden rounded-md p-2 hover:bg-accent"
                        aria-label="Toggle menu"
                    >
                        <Menu className="h-5 w-5" />
                    </button>

                    {/* Search */}
                    <div className="flex-1 max-w-md md:w-[470px]">
                        <div className="relative">
                            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#99A0AE]" />
                            <Input
                                placeholder="Search across accounts, transactions, wallets & settings"
                                className="pl-9 bg-muted/50"
                            />
                        </div>
                    </div>
                </div>

                {/* Right section */}
                <div className="flex items-center gap-2">
                    {/* User role badge */}
                    <Badge
                        variant="secondary"
                        className="hidden sm:flex gap-1.5 px-3 h-11 bg-muted text-sm rounded-l-full rounded-r-none "
                    >
                        <img alt="Super Admin Icon" src={SuperAdminIcon} />
                        <span className="text-xs font-medium">Super Admin</span>
                    </Badge>

                    <Badge
                        variant="secondary"
                        className="hidden sm:flex gap-1.5 px-3 h-11 bg-muted text-sm rounded-r-full rounded-l-none "
                    >
                        <span className="text-xs font-medium">OC</span>
                    </Badge>

                    {/* User menu */}
                    <UserMenu />
                </div>
            </div>
        </header>
    )
}

export default Header
